var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "28px",
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Starting-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Starting-Components-Part-1",
    transform: "translate(-599.000000, -2419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-3",
    transform: "translate(599.000000, 2419.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1015,1.211 C21.16625,1.211 26.915,6.95975 26.915,14.024675 C26.915,21.089425 21.16625,26.83625 14.1015,26.83625 C7.03675,26.83625 1.28975,21.089425 1.28975,14.024675 C1.28975,6.95975 7.03675,1.211 14.1015,1.211 L14.1015,1.211 Z M14.1015,0.04725 C6.38225,0.04725 0.126175,6.305425 0.126175,14.024675 C0.126175,21.74375 6.38225,28 14.1015,28 C21.82075,28 28.07875,21.74375 28.07875,14.024675 C28.07875,6.305425 21.82075,0.04725 14.1015,0.04725 Z M20.46275,9.723 C20.433,9.65125 20.391,9.58825 20.33675,9.534 L16.261,5.45825 C16.2085,5.40575 16.14375,5.362175 16.07375,5.334 C16.00375,5.30425 15.92675,5.2885 15.84975,5.2885 L8.2775,5.2885 C7.95725,5.2885 7.6965,5.54925 7.6965,5.8695 L7.6965,22.17775 C7.6965,22.49975 7.95725,22.7605 8.2775,22.7605 L19.9255,22.7605 C20.2475,22.7605 20.50825,22.49975 20.50825,22.17775 L20.50825,9.947 C20.50825,9.86825 20.492675,9.793 20.46275,9.723 Z M16.4325,7.2765 L18.52025,9.36425 L16.4325,9.36425 L16.4325,7.2765 Z M8.86025,21.595 L8.86025,6.45225 L15.267,6.45225 L15.267,9.947 C15.267,10.269 15.52775,10.52975 15.84975,10.52975 L19.3445,10.52975 L19.3445,21.595 L8.86025,21.595 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.65ed9bc2eb895ea44e1886a0800e0f71.svg";
export { ForwardRef as ReactComponent };